export default "__VITE_ASSET__h_wNmhYM__"